import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
interface Props {
  onNext: () => void;
}
export const PostScreen2Callback = ({
  onNext
}: Props) => {
  const [revealed, setRevealed] = useState(false);
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-46">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-slate-950 to-slate-950" data-id="element-47" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-48">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-green-500 font-semibold mb-4" data-id="element-49">
          01 — You Asked
        </motion.span>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-6" data-id="element-50">
          <div className="flex items-center space-x-2 mb-3" data-id="element-51">
            <Sparkles className="w-4 h-4 text-green-500" data-id="element-52" />
            <p className="text-xs text-slate-500 uppercase tracking-wider" data-id="element-53">
              From your pre-ERA poll
            </p>
          </div>
          <p className="text-slate-400 text-sm italic mb-2" data-id="element-54">
            "What's the most important first 30 seconds in a congress
            conversation?"
          </p>
          <p className="text-white text-lg font-semibold" data-id="element-55">
            You said:{' '}
            <span className="text-green-400" data-id="element-56">Listening & Asking questions</span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="bg-slate-900/80 border border-slate-800 rounded-3xl overflow-hidden mb-6" data-id="element-57">
          <div className="relative h-48" data-id="element-58">
            <video src="https://cdn.magicpatterns.com/uploads/5wPyLmrLcJy9mKAv4BEyBB/women.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-59" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent" data-id="element-60" />
          </div>
          <div className="p-4" data-id="element-61">
            <p className="text-white font-medium mb-2" data-id="element-62">
              Here's what we saw at ERA:
            </p>
            <p className="text-sm text-slate-400 leading-relaxed" data-id="element-63">
              The most memorable booth conversations started with genuine
              curiosity. Teams who listened first built deeper connections.
            </p>
          </div>
        </motion.div>

        <div className="mt-auto" data-id="element-64">
          <button onClick={() => {
          setRevealed(true);
          setTimeout(onNext, 1200);
        }} disabled={revealed} className="w-full bg-green-600 hover:bg-green-500 disabled:bg-green-700 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-65">
            <span data-id="element-66">{revealed ? 'You were right ✓' : 'Continue'}</span>
            {!revealed && <ArrowRight className="w-5 h-5" data-id="element-67" />}
          </button>
        </div>
      </div>
    </div>;
};